export enum ProgressStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}
